/**
 * Use this to provide hooks in your views for other views to hang elements onto.
 *
 * Usage:
 *
 *      <div data-bind="hook: someObservable">
 *          Optional default content
 *      </div>
 *
 *      <!-- ko hang: someObservable -->
 *          <div>hello world</div>
 *      <!-- /ko -->
 *
 * More Info:
 *
 *  - Hook also supports virtual elements.
 *  - When empty, hook will set display: none on its element
 */
define('ko/customBinding/hook',['knockout', 'jquery'], function(ko, $) {

    function cloneNodes(nodesArray) {

        var newNodesArray = [];

        for (var i = 0, j = nodesArray.length; i < j; i++) {
            newNodesArray.push(nodesArray[i].cloneNode(true));
        }
        return newNodesArray;
    }

    function isBlankElement(element) {
        var children = ko.virtualElements.childNodes(element);

        for (var i = 0, j = children.length, child; i < j; i++) {

            child = children[i];

            // Element nodes (1) or non-empty text nodes (3)
            if (child.nodeType === 1 || (child.nodeType === 3 && child.textContent.trim() !== '')) {
                return false;
            }
        }

        return true;
    }

    ko.bindingHandlers.hook = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {

            ko.utils.domData.set(element, 'defaultChildren', cloneNodes(ko.virtualElements.childNodes(element)));

            return { 'controlsDescendantBindings': true };
        },
        update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var hang = valueAccessor()(),
                defaultChildren = ko.utils.domData.get(element, 'defaultChildren');

            if (!hang) {

                if (!defaultChildren.length) {

                    if (element.style) {
                        element.style.display = 'none';
                    }

                    ko.virtualElements.emptyNode(element);
                    return;
                }

                ko.virtualElements.setDomNodeChildren(element, cloneNodes(defaultChildren));
                ko.applyBindingsToDescendants(bindingContext, element);

                if (element.style && isBlankElement(element)) {
                    element.style.display = 'none';
                }

                return;
            }

            if (element.style) {
                element.style.removeProperty('display');
            }

            ko.virtualElements.setDomNodeChildren(element, hang.children);
            ko.applyBindingsToDescendants(hang.bindingContext, element);
        }
    };

    ko.bindingHandlers.hang = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {

            var children = ko.virtualElements.childNodes(element);

            ko.virtualElements.emptyNode(element);

            valueAccessor()({
                children: children,
                bindingContext: bindingContext
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                valueAccessor()(null);
            });

            return { 'controlsDescendantBindings': true };
        }
    };

    ko.virtualElements.allowedBindings.hook = true;
    ko.virtualElements.allowedBindings.hang = true;

});

